import { useTranslation } from 'react-i18next'

import { ChipInput, Divider } from '@reveni-io/reveni-ui'

import { statuses } from '@/returns/constants'

import * as Styles from './styles'

const TransactionTags = ({ tags, onChangeTags, status }) => {
  const { t } = useTranslation()

  const isCancelled = status === statuses.cancelled

  if (isCancelled && !tags?.length) return null

  return (
    <>
      <Divider />
      <Styles.MainContainer>
        <ChipInput
          value={tags}
          onChange={onChangeTags}
          borderless
          backgroundColor="transparent"
          disabled={isCancelled}
          addTagLabel={t('Añadir tags')}
          helperText={t(
            'Pulsa Enter o , para añadir un tag. Pega varios valores separados por comas para añadirlos todos a la vez.'
          )}
        />
      </Styles.MainContainer>
    </>
  )
}

export default TransactionTags
